module.exports = __webpack_public_path__ + "img/ugly_or_beuty_lakota.bd580adc.jpg";